// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import type { FacilityId, TaskTimeEntry } from '@evolvemep/api-ts';
import { Flex, Stack, Text } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { convertSecondsToDuration } from 'components/Mantine/durationHelpers';
import { EvolveLink } from 'components/Mantine/Navigation/EvolveLink';
import { TimeEntryMenu } from 'modules/Shop/TimeTracking/TimeEntryMenu';
import { getDisplayNameWO } from 'modules/Shop/WorkOrders/WorkOrderDetail/common';

type Props = {
  entry: TaskTimeEntry;
} & (
  | {
      showMenu?: false;
    }
  | {
      showMenu: true;
      facilityId: FacilityId;
      onDeleteEntry: (entry: TaskTimeEntry) => void;
      onEntryUpdated: (updatedEntry: TaskTimeEntry) => void;
    }
);

export const TimeEntry = ({ entry, ...props }: Props) => (
  <Flex align="center" justify="space-between" px="md">
    <Stack gap={2}>
      <Flex>
        <EvolveLink className="link-dark" to={`/task-viewer/${entry.taskId}`} from="Time Tracking">
          <Text c="dark" style={{ whiteSpace: 'nowrap' }}>
            {entry.taskName}
          </Text>
        </EvolveLink>
      </Flex>
      <Text fz="sm" c="dimmed">
        {entry.workOrderItemName}
      </Text>
      <Flex fz="sm" align="center" gap={4}>
        <Text c="dimmed">{entry.projectName}</Text>
        <EvolveIcon icon="ArrowRight" color="gray.5" size={8} />
        <EvolveLink
          className="kanban-work-order-link kanban-work-order-small-link"
          to={`/work-orders/${entry.workOrderId}`}
          from="Time Tracking"
        >
          {getDisplayNameWO(entry)}
        </EvolveLink>
        <EvolveIcon icon="ArrowRight" color="gray.5" size={8} />
        <Text c="dimmed">{entry.workOrderItemName}</Text>
      </Flex>
    </Stack>
    <Flex align="center" gap="md">
      {convertSecondsToDuration(entry.totalSeconds)}
      {props.showMenu && <TimeEntryMenu entry={entry} {...props} />}
    </Flex>
  </Flex>
);
